import { render, staticRenderFns } from "./adminReview.vue?vue&type=template&id=2ff07e94&scoped=true&"
import script from "./adminReview.vue?vue&type=script&lang=js&"
export * from "./adminReview.vue?vue&type=script&lang=js&"
import style0 from "./adminReview.vue?vue&type=style&index=0&id=2ff07e94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff07e94",
  null
  
)

export default component.exports